import { ExercisesService } from "@/api/exercises";
import type {
  Exercise,
  ExerciseRequestData,
  ExercisesParams,
  ExercisesResponse,
} from "@/api/exercises/types";
import { EXERCISES_PER_PAGE } from "@/constants/exercises";
import { buildFormData } from "@/utils/form-data-builder";

export class ExercisesRepository {
  private static _instance: ExercisesRepository;

  static get instance(): ExercisesRepository {
    if (!this._instance) {
      this._instance = new ExercisesRepository();
    }
    return this._instance;
  }

  private constructor() {}

  async getExercises(params: ExercisesParams = {}): Promise<ExercisesResponse> {
    const response = await ExercisesService.instance.getExercises(params);

    return {
      data: response.data.exercises,
      meta: {
        currentPage: parseInt(
          response.headers["x-current-page"] || String(params.page || 1),
          10,
        ),
        perPage: parseInt(
          response.headers["x-per-page"] ||
            String(params.perPage ?? EXERCISES_PER_PAGE),
          10,
        ),
        total: parseInt(response.headers["x-total-count"] || "0", 10),
        totalPages: parseInt(response.headers["x-total-pages"] || "1", 10),
      },
    };
  }

  async getExercise(id: string): Promise<Exercise> {
    return ExercisesService.instance.getExercise(id);
  }

  async createExercise(data: ExerciseRequestData): Promise<Exercise> {
    const { thumbnail, ...exerciseData } = data.exercise;

    const formData = buildFormData(
      { exercise: exerciseData },
      thumbnail
        ? { fileField: { key: "exercise[thumbnail_image]", value: thumbnail } }
        : {},
    );

    return ExercisesService.instance.createExercise(formData);
  }

  async updateExercise(
    id: string,
    data: ExerciseRequestData,
  ): Promise<Exercise> {
    const { thumbnail, ...exerciseData } = data.exercise;

    const formData = buildFormData(
      { exercise: exerciseData },
      thumbnail
        ? { fileField: { key: "exercise[thumbnail_image]", value: thumbnail } }
        : {},
    );

    return ExercisesService.instance.updateExercise(id, formData);
  }
}
